import {Directive, HostListener, inject, Input} from '@angular/core';
import {AnalyticsService} from '../../application/analytics.service';

@Directive({
  selector: '[trackEvent]',
  standalone: true
})
export class TrackEventDirective {
  @Input('trackEvent') params!: {
    trackEvent: string;
    [key: string]: any;
  };

  private readonly analyticsService = inject(AnalyticsService);

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    const {
      trackEvent: eventName,
      ...eventParams
    } = this.params;
    this.analyticsService.logEvent(eventName, {
      category: 'interaction',
      label: (event.target as HTMLElement).tagName,
      ...(eventParams ?? {}),
      timestamp: new Date()
    });
  }
}
